module.exports = __webpack_public_path__ + "assets/img/5.91186a6f.png";